import Blue from "../core";

new Blue({
  name: 'Drag Uploader',
  selector: ".drag-uploader",
  setup(dragUploader) {
    let fileCount = 1;
    const filenameContainer = dragUploader.querySelector('.file-list');
    const dropzone = dragUploader.querySelector('.drag-uploader__step1');
    const fileInput = dropzone.querySelector('input[type=file]');

    fileInput.addEventListener('change', function () {
      for (let i = 0; i < fileInput.files.length; i++) {
        const newDiv = document.createElement('div');
        newDiv.classList.add('uploader-input');

        const closeButton = document.createElement('button');
        closeButton.classList.add('uploader-remove');
        closeButton.onclick = function (event) {
          event.target.parentElement.remove();
          fileCount--;
        };
                
        const dataTransfer = new DataTransfer();
        dataTransfer.items.add(fileInput.files[i]);

        const inputClone = fileInput.cloneNode(true);
        inputClone.files = dataTransfer.files;
        inputClone.id = "dragUploader" + fileCount;
        inputClone.multiple = false;

        newDiv.innerHTML += "<h6 class='uploader-file'>" + inputClone.value.split('\\').pop() + "</h6>";
        newDiv.appendChild(inputClone);
        newDiv.appendChild(closeButton);
        filenameContainer.appendChild(newDiv);
        fileCount++;
      }
      fileInput.value = '';
    });

    fileInput.addEventListener('dragenter', function () {
      dropzone.classList.add('dragover');
    });

    fileInput.addEventListener('dragleave', function () {
      dropzone.classList.remove('dragover');
    });
  }
});











